import React from 'react'
import { MdDragIndicator } from 'react-icons/md'

interface DonorPrioritySectionProps {
  position: number
  isDraggable: boolean
  sortableProps?: {
    attributes: Record<string, any>
    listeners: Record<string, any> | undefined
  }
}

const DonorPrioritySection: React.FC<DonorPrioritySectionProps> = ({ position, isDraggable, sortableProps }) => {
  return (
    <div className="donor-card__priority-section">
      {isDraggable && sortableProps && (
        <button
          className="drag-handle-list"
          {...sortableProps.attributes}
          {...sortableProps.listeners}
          aria-label="Drag to reorder"
        >
          <MdDragIndicator size={20} />
        </button>
      )}
      <div className="priority-badge">
        <span className="priority-badge__text">PRIORIDADE</span>
        <span className="priority-badge__number">{position}</span>
      </div>
    </div>
  )
}

export default DonorPrioritySection
